import { render, staticRenderFns } from "./CytomineViewer.vue?vue&type=template&id=5a27e53b&scoped=true&"
import script from "./CytomineViewer.vue?vue&type=script&lang=js&"
export * from "./CytomineViewer.vue?vue&type=script&lang=js&"
import style0 from "./CytomineViewer.vue?vue&type=style&index=0&id=5a27e53b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a27e53b",
  null
  
)

export default component.exports